export default "__VITE_ASSET__bb167247__"